import React from "react";
import TableBase from "./Base";
import { DateTimeFormat } from "../../helpers/utils";

const ShippersTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Order ID",
			dataIndex: "order_id",
			width: 100,
			ellipsis: true,
		},
		{
			title: "Email",
			width: 150,
			ellipsis: true,
			render(record) {
				return <span>{record.admin.email}</span>;
			},
		},
		{
			title: "Created At",
			dataIndex: "created_at",
			width: 150,
			ellipsis: true,
			render(value) {
				return DateTimeFormat(value);
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default ShippersTable;
